<template>
  <div class="container" v-if="breadcrumb.length > 0">
    <span v-for="route in breadcrumb" :key="route.name" class="Link">
      <span class="Link-Route" @click="navigate(route)">
        {{ routeToName(route) }}
      </span>

      <span>></span>
    </span>
    {{ routeName }}
  </div>
</template>

<script>
import get from 'lodash/get'
import has from 'lodash/has'
import { mapGetters } from 'vuex'

/**
 * Define custom route name function, where the key is the routeName
 * i.e: "theme" route is for a theme, use the title's theme as breadcrumb
 */
const CUSTOM_ROUTE_MAP = {
  theme: (route, { theme }) => {
    return get(theme, ['title'], null)
  }
}

export default {
  name: 'DesktopBreadcrumb',
  computed: {
    ...mapGetters({
      lessonStep: 'currentLessonStep',
      theme: 'currentTheme'
    }),
    routeName() {
      const currentRouteName = this.$router.currentRoute.name

      return this.routeToName(currentRouteName)
    },
    breadcrumb() {
      return get(this.$router.currentRoute, ['meta', 'breadcrumb'], [])
    }
  },
  methods: {
    /**
     * Map a route name to a translation key
     * @param {string} key
     * @returns {string}
     */
    toTranslation(key) {
      return `routes.${key}`
    },
    /**
     * Map the route name to a readable label
     * @param {string} routeName
     * @returns {string}
     */
    routeToName(routeName) {
      if (has(CUSTOM_ROUTE_MAP, routeName)) {
        return CUSTOM_ROUTE_MAP[routeName](routeName, {
          theme: this.theme,
          lessonStep: this.lessonStep
        })
      }

      const translationKey = this.toTranslation(routeName)

      return this.$t(translationKey)
    },
    /**
     * Navigate to the given route
     */
    navigate(route) {
      this.$router.push({
        name: route,
        params: {
          themeId: get(this.theme, ['id'], null),
          lessonStepId: get(this.lessonStep, ['id'], null)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 30px 0;
  font-size: 15px;
}

.Link {
  .Link-Route {
    cursor: pointer;
    font-weight: 400;

    &:hover {
      font-weight: 600;
    }
  }
}
</style>
